export enum IssuePriority {
    standard = 5,
    priority,
    critical,
}

export const getIssuePriorityNameRu = (priority: IssuePriority | null | undefined) => {
    switch (priority) {
        case IssuePriority.standard: return 'Стандарт';
        case IssuePriority.priority: return 'Приоритет';
        case IssuePriority.critical: return 'Критическая';
        default: return 'статус не определен';
    }

    return undefined;
}